import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BtnBar, CtaBtn, Dialog, SecondaryBtn, WarningAlert } from '@tmapy/style-guide';

import { QUERY_STATE } from '../../constants';

import { serviceOrderBtnMessages, serviceOrderDetailMessages } from './serviceOrderMessages';

type ServiceOrderConfirmDialogProps = {
  queryState: QUERY_STATE;
  onConfirm(): void;
  onClose(): void;
};

/**
 * Potvrzení je nevratné a bere cenu z rozpracované žádosti — neuložená změna
 * ve formuláři by se do dokladu nedostala, tak se na ni pracovnice zeptáme.
 * Chyby potvrzení (změněný ceník, neúplné údaje) hlásí stránka pod hlavičkou,
 * proto se dialog na rozdíl od zaplacení po odeslání zavírá.
 */
export const ServiceOrderConfirmDialog: React.FC<ServiceOrderConfirmDialogProps> = ({
  queryState,
  onConfirm,
  onClose,
}) => {
  const isSaving = queryState === QUERY_STATE.WAITING;

  return (
    <Dialog width='480px' onEscKeyDown={onClose} onOverlayClick={onClose}>
      <div className='sg-a-p-2 sg-u-vs-2'>
        <h2 className='sg-u-type-h2'>
          <FormattedMessage {...serviceOrderDetailMessages.confirmTitle} />
        </h2>
        <WarningAlert>
          <FormattedMessage {...serviceOrderDetailMessages.confirmDialogInfo} />
        </WarningAlert>
        <BtnBar>
          <CtaBtn isDisabled={isSaving} onClick={onConfirm}>
            <FormattedMessage {...serviceOrderBtnMessages.confirm} />
          </CtaBtn>
          <SecondaryBtn isDanger isDisabled={isSaving} onClick={onClose}>
            <FormattedMessage {...serviceOrderBtnMessages.cancel} />
          </SecondaryBtn>
        </BtnBar>
      </div>
    </Dialog>
  );
};
